import { isLocal, isPreview } from "@grafit/shared/utils/envs.front";

function setFavicon(href: string) {
  const linkElement = document.querySelector("link[rel='icon']") as unknown as HTMLLinkElement;
  linkElement.href = href;
}

export function setupCustomFavicon() {
  if (isLocal()) {
    setFavicon("/logo-grafit-orange.svg");
  }

  if (isPreview()) {
    setFavicon("/logo-grafit-yellow.svg");
  }
}
